(() => {
  if (window.arcticCartPageInitialized) return;
  window.arcticCartPageInitialized = true;
  let busy = false;
  let quantityTimer;
  let refreshTimer;
  const root = () => document.querySelector('[data-cart-page]');
  const setBusy = (value) => {
    busy = value;
    const page = root();
    if (!page) return;
    page.setAttribute('aria-busy', String(value));
    page.querySelectorAll('button, input').forEach((element) => { element.disabled = value; });
    page.querySelectorAll('[data-cart-page-remove]').forEach((element) => { element.setAttribute('aria-disabled', String(value)); });
    const drawer = document.querySelector('#cart-drawer-section');
    if (drawer) drawer.inert = value;
  };
  const showError = (message) => {
    const page = root();
    const error = page?.querySelector('[data-cart-page-error]');
    if (error) {
      error.textContent = message || page.dataset.error;
      error.hidden = false;
    }
  };
  const identity = (row, quantity) => ({
    key: row.dataset.key,
    variantId: row.dataset.variantId,
    properties: JSON.parse(row.dataset.properties || '{}'),
    planId: row.dataset.planId,
    quantity
  });
  const quantityChanges = () => {
    const page = root();
    const operations = [];
    for (const input of page.querySelectorAll('[data-cart-page-quantity]:not([readonly])')) {
      const quantity = Number(input.value);
      if (input.value.trim() === '' || !Number.isSafeInteger(quantity) || quantity < 0) {
        showError(page.dataset.invalid);
        input.focus();
        return null;
      }
      if (quantity !== Number(input.dataset.originalQuantity)) {
        operations.push(identity(input.closest('[data-cart-page-item]'), quantity));
      }
    }
    return operations;
  };
  const refresh = async (focus) => {
    const page = root();
    if (!page) return;
    const url = new URL(window.location.href);
    url.searchParams.set('sections', page.dataset.sectionId);
    const response = await fetch(url, { cache: 'no-store' });
    if (!response.ok) throw new Error(page.dataset.error);
    const sections = await response.json();
    const html = sections[page.dataset.sectionId];
    if (!html) throw new Error(page.dataset.error);
    const documentFragment = new DOMParser().parseFromString(html, 'text/html');
    const next = documentFragment.querySelector('[data-cart-page]');
    if (!next) throw new Error(page.dataset.error);
    page.replaceWith(next);
    const status = next.querySelector('[data-cart-page-status]');
    status.textContent = status.dataset.updated;
    if (focus) {
      const row = Array.from(next.querySelectorAll('[data-cart-page-item]')).find((item) => item.dataset.variantId === focus.variantId && item.dataset.properties === focus.properties);
      const target = row?.querySelector(focus.selector) || next.querySelector('[data-cart-page-checkout], h1');
      if (target) {
        if (!target.matches('button, input, a')) target.tabIndex = -1;
        target.focus({ preventScroll: true });
      }
    }
  };
  const apply = async (extra, checkout = false) => {
    clearTimeout(quantityTimer);
    clearTimeout(refreshTimer);
    if (busy || !root()) return;
    const operations = quantityChanges();
    if (!operations) return;
    if (extra) {
      const existing = operations.findIndex((operation) => operation.key === extra.key);
      if (existing >= 0) operations.splice(existing, 1);
      operations.push(extra);
    }
    if (!operations.length && !checkout) return;
    const active = document.activeElement;
    const activeRow = active.closest?.('[data-cart-page-item]');
    const focus = activeRow ? {
      variantId: activeRow.dataset.variantId,
      properties: activeRow.dataset.properties,
      selector: active.matches('[data-cart-page-subscription]') ? '[data-cart-page-subscription]' : '[data-cart-page-quantity]'
    } : null;
    const error = root().querySelector('[data-cart-page-error]');
    error.hidden = true;
    setBusy(true);
    try {
      if (!window.arcticCartPage) throw new Error(root().dataset.error);
      if (operations.length) await window.arcticCartPage.change(operations);
      if (checkout) {
        await window.arcticCartPage.checkout();
        return;
      }
      await refresh(focus);
    } catch (error) {
      if (operations.length) {
        try { await window.arcticCartPage?.refresh(); } catch (_) {}
        try { await refresh(focus); } catch (_) {}
      }
      showError(error.message === 'Failed to fetch' ? undefined : error.message);
    } finally {
      setBusy(false);
    }
  };
  document.addEventListener('input', (event) => {
    if (!event.target.matches('[data-cart-page-quantity]') || busy) return;
    clearTimeout(quantityTimer);
    quantityTimer = setTimeout(() => apply(), 500);
  });
  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-cart-page-quantity]') && !busy) apply();
  });
  document.addEventListener('click', (event) => {
    const control = event.target.closest('[data-cart-page-step], [data-cart-page-subscription], [data-cart-page-remove]');
    if (!control || !control.closest('[data-cart-page]')) return;
    event.preventDefault();
    if (busy) return;
    const row = control.closest('[data-cart-page-item]');
    const input = row.querySelector('[data-cart-page-quantity]');
    if (control.matches('[data-cart-page-step]')) {
      const current = Number(input.value);
      input.value = Math.max(0, (Number.isSafeInteger(current) ? current : Number(input.dataset.originalQuantity)) + Number(control.dataset.cartPageStep));
      clearTimeout(quantityTimer);
      quantityTimer = setTimeout(() => apply(), 250);
    } else if (control.matches('[data-cart-page-remove]')) {
      input.value = 0;
      apply();
    } else {
      const operation = identity(row, Number(input.value));
      operation.sellingPlan = control.getAttribute('aria-checked') === 'true' ? null : Number(control.dataset.plan);
      apply(operation);
    }
  });
  document.addEventListener('submit', (event) => {
    if (!event.target.matches('[data-cart-page] form')) return;
    event.preventDefault();
    if (!busy) apply(null, event.submitter?.name === 'checkout');
  });
  document.addEventListener('arctic:cart-updated', () => {
    if (busy || !root() || document.querySelector('[data-cart-drawer-panel].is-open')) return;
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(async () => {
      if (busy) return;
      setBusy(true);
      try { await refresh(); } catch (error) { showError(); }
      finally { setBusy(false); }
    }, 300);
  });
})();
